import React, { useRef } from 'react';
import { Button, Dropdown, Tag, useMediaQueryContext } from '@fourthwall/components';
import { ArrowShortDownIcon } from '@fourthwall/icons';
import * as S from './ThemeStatusButton.styled';
import { useThemeStatusButton } from './useThemeStatusButton';
export const ThemeStatusButton = ({ isActive, onActivate }) => {
    const media = useMediaQueryContext();
    const buttonRef = useRef(null);
    const { handleActivateSelectedTheme } = useThemeStatusButton();
    const handleDropdownClose = () => {
        buttonRef.current?.click();
    };
    if (isActive) {
        return React.createElement(Tag, { label: "Live theme", appearance: "success", size: media.laptop ? 'large' : 'small' });
    }
    return (React.createElement(Dropdown, { content: React.createElement(S.Container, null,
            React.createElement(Button, { label: "Publish as active theme", appearance: "primary", size: "small", onClick: () => {
                    handleActivateSelectedTheme(onActivate);
                    handleDropdownClose();
                } })), position: "bottom-end", maxWidth: 368 },
        React.createElement("button", { ref: buttonRef },
            React.createElement(Tag, { label: "Inactive theme", appearance: "default", size: media.laptop ? 'large' : 'small', icon: ArrowShortDownIcon, hoverable: true }))));
};
